import React from "react";
import StudyShell from "@/components/study/StudyShell";
import StudyRunner from "@/components/study/StudyRunner";
import { STUDY } from "@/constants/testIds";

export default function StudyMissed() {
  return (
    <StudyShell testId={STUDY.missedPage}>
      <h1 className="text-2xl font-bold text-[var(--ibp-ink)]">Missed questions</h1>
      <p className="mt-1 text-sm text-[color:rgba(11,18,32,0.6)]">
        A question leaves this list after you answer it correctly twice in a row.
      </p>
      <div className="mt-6">
        <StudyRunner mode="missed" emptyText="No missed questions. Great work!" />
      </div>
    </StudyShell>
  );
}
